import React, { useState, useEffect, useMemo, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import LoiNhuanApi from "service/BaoCao/LoiNhuanApi";
import { formatNumber2 } from "../../../../utils/currencyFormat";
import { getDate } from "../../../../utils/formatDate";
import { ContentTable } from "./ContentTable";
import ChiTietHopDong from "service/chiTietHopDongApi";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainerV2";
import CustomerDetail from "containers/Common/Customer/customerDetail";
import { ModalChiTietHopDong } from "../../../NhanVay/ChiTietHopDong/ModalChiTietHopDong";
import { format, startOfYear, endOfYear } from "date-fns";
import BtnInChiTiet from "../../LoiNhuan/InVaXuatExcel/BtnInChiTiet";
import BtnXuatExcel from "../../LoiNhuan/InVaXuatExcel/BtnXuatExcel";
import CauHinhApi from "service/cauHinhApi";
import cauHinh from "utils/cauHinh";
const mapTypeToInt = (typeString) => {
  switch (typeString) {
    case "tinchap":
      return 1;
    case "camdo":
      return 2;
    case "tragop":
      return 3;
    case "banhang":
      return 4;
    case "thungoai":
      return 5;
    case "chingoai":
      return 6;
    case "chinhanvay":
      return 7;
    case "thutrichlap":
      return 8;
    case "chitrichlap":
      return 9;
    default:
      return 1;
  }
};

const getColumns = (reportTypeInt, totals = {}, isWinmoney = false) => {
  const baseCols = [
    {
      header: "Ngày",
      accessor: "NgayGiaoDich",
      className: "flex-basis-7",
      align: "text-center",
      render: (item) => getDate(item.NgayGiaoDich),
    },
    {
      header: "Nhân viên",
      accessor: "NhanVien",
      className: "flex-basis-8",
      align: "text-center",
    },
  ];

  const customerCol = () => ({
    header: reportTypeInt === 7 ? "Chủ nợ" : "Khách hàng",
    accessor: "KhachHang",
    className: `flex-basis-10`,
    align: "text-center",
    isCustomerLink: true,
  });

  const contractCol = {
    header: "Hợp đồng",
    accessor: "MaHopDong",
    className: "flex-basis-20",
    align: "text-center",
    isContractLink: true,
  };
  const colTienLai = {
    header: "Tiền thu lãi",
    accessor: "Cot_TienThuLai",
    className: "flex-basis-10",
    align: "text-right",
    render: (item) => formatNumber2(item.Cot_TienThuLai),
    sum: totals.Sum_TienThuLai,
  };
  const colPhiKy = {
    header: "Phí hàng kỳ",
    accessor: "Cot_PhiHangKy",
    className: "flex-basis-10",
    align: "text-right",
    render: (item) => formatNumber2(item.Cot_PhiHangKy),
    sum: totals.Sum_PhiHangKy,
  };
  // Nhà Winmoney gộp luôn phí chậm đóng lãi vào cột này thay vì tách cột riêng.
  // Có gộp thì các cột mới cộng lại khớp với cột Tổng thu, vì Cot_TongTien phía
  // stored procedure vốn đã tính cả khoản phạt đó.
  const colThuKhac = {
    header: "Tiền thu khác",
    accessor: "Cot_TienThuKhac",
    className: "flex-basis-10",
    align: "text-right",
    render: (item) =>
      formatNumber2(
        Number(item.Cot_TienThuKhac || 0) +
          (isWinmoney ? Number(item.Cot_PhatChamDongLai || 0) : 0),
      ),
    sum: isWinmoney
      ? Number(totals.Sum_TienThuKhac || 0) +
        Number(totals.Sum_PhatChamDongLai || 0)
      : totals.Sum_TienThuKhac,
  };
  const colPhiKho = {
    header: "Phí kho",
    accessor: "Cot_PhiKho",
    className: "flex-basis-10",
    align: "text-right",
    render: (item) => formatNumber2(item.Cot_PhiKho),
    sum: totals.Sum_PhiKho,
  };
  const colTongThu = {
    header: "Tổng thu",
    accessor: "Cot_TongTien",
    className: "flex-basis-10",
    align: "text-right",
    render: (item) => formatNumber2(item.Cot_TongTien),
    sum: totals.Sum_TongLoiNhuan,
  };
  const colTongChi = {
    header: "Tổng chi",
    accessor: "Cot_TongTien",
    className: "flex-basis-10",
    align: "text-right",
    render: (item) => formatNumber2(item.Cot_TongTien),
    sum: totals.Sum_TongLoiNhuan,
  };

  if ([1, 2, 3, 4].includes(reportTypeInt)) {
    return [
      ...baseCols,
      customerCol("15"),
      contractCol,
      colTienLai,
      colPhiKy,
      colThuKhac,
      colPhiKho,
      colTongThu,
    ];
  }

  if (reportTypeInt === 7) {
    const colChiLai = {
      header: "Tiền chi lãi",
      accessor: "Cot_TienThuLai",
      className: "flex-basis-10",
      align: "text-right",
      render: (item) => formatNumber2(item.Cot_TienThuLai),
      sum: totals.Sum_TienThuLai,
    };
    const colChiKhac = {
      header: "Chi khác",
      accessor: "Cot_TienThuKhac",
      className: "flex-basis-10",
      align: "text-right",
      render: (item) => formatNumber2(item.Cot_TienThuKhac),
      sum: totals.Sum_TienThuKhac,
    };
    return [
      ...baseCols,
      customerCol("20"),
      contractCol,
      colChiLai,
      colChiKhac,
      colPhiKho,
      colTongChi,
    ];
  }

  if ([5, 6, 8, 9].includes(reportTypeInt)) {
    const colLoaiPhieu = {
      header: "Loại phiếu",
      accessor: "DienGiai",
      className: "flex-basis-25",
      align: "text-center",
    };
    const colSoTien = {
      header: "Số tiền",
      accessor: "Cot_TongTien",
      className: "flex-basis-25",
      align: "text-right",
      render: (item) => formatNumber2(item.Cot_TongTien),
      sum: totals.Sum_TongLoiNhuan,
    };
    return [
      {
        header: "Ngày",
        accessor: "NgayGiaoDich",
        className: "flex-basis-10",
        align: "text-center",
        render: (item) => getDate(item.NgayGiaoDich),
      },
      {
        header: "Nhân viên",
        accessor: "NhanVien",
        className: "flex-basis-15",
        align: "text-left",
      },
      customerCol("25"),
      colLoaiPhieu,
      colSoTien,
    ];
  }
  return [];
};

export const TableDanhSachLoiNhuan = ({
  show,
  onHide,
  type,
  title,
  filters,
  RoleLoiNhuanIn,
}) => {
  const [data, setData] = useState({ list: [], totalRecords: 0, sums: {} });
  const [loading, setLoading] = useState(true);
  const [pageIndex, setPageIndex] = useState(1);
  const pageSize = 20;
  const [hideParent, setHideParent] = useState(false);
  const [showModalHopDong, setShowModalHopDong] = useState(false);
  const [hopDongDetail, setHopDongDetail] = useState(null);
  const [showModalKhachHang, setShowModalKhachHang] = useState(false);
  const [modalKhachHangData, setModalKhachHangData] = useState(null);
  const [showModalNhanVay, setShowModalNhanVay] = useState(false);
  const [nhanVayItem, setNhanVayItem] = useState(null);
  // Cột "Phí chậm đóng lãi" chỉ dựng cho nhà Winmoney
  const [isWinmoney, setIsWinmoney] = useState(false);

  useEffect(() => {
    if (show) setPageIndex(1);
  }, [show, type]);

  useEffect(() => {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200 && response.data.length > 0) {
        const configWinmoney = response.data.find(
          (e) =>
            e.keyConfig &&
            e.keyConfig.toUpperCase() === cauHinh.sKey.IsWinmoney.toUpperCase(),
        );
        if (configWinmoney != null && configWinmoney.valueConfig === "1") {
          setIsWinmoney(true);
        }
      }
    });
  }, []);

  const fetchDetails = useCallback(() => {
    setLoading(true);
    let dateFrom = filters.dtFrom;
    let dateTo = filters.dtTo;

    if (!dateFrom || !dateTo) {
      dateFrom = startOfYear(new Date());
      dateTo = endOfYear(new Date());
    }
    const reportTypeInt = mapTypeToInt(type);
    const strFrom = format(dateFrom, "dd/MM/yyyy");
    const strTo = format(dateTo, "dd/MM/yyyy");

    LoiNhuanApi.getChiTiet(strFrom, strTo, reportTypeInt, pageIndex, pageSize)
      .then((res) => {
        if (res.status === 200 && res.data) {
          const { Data, TotalRecords, ...sums } = res.data;
          setData({
            list: Data || [],
            totalRecords: TotalRecords || 0,
            sums: sums,
          });
        } else {
          setData({ list: [], totalRecords: 0, sums: {} });
        }
      })
      .catch(() => setData({ list: [], totalRecords: 0, sums: {} }))
      .finally(() => setLoading(false));
  }, [type, filters, pageIndex, show]);

  useEffect(() => {
    fetchDetails();
  }, [pageIndex, show]);

  const handleOpenModalHopDong = (item) => {
    if (item.ChoVayID) {
      setShowModalHopDong(true);
      setHideParent(true);
      ChiTietHopDong.getChiTietHopDong1(item.ChoVayID).then((res) =>
        setHopDongDetail(res.data),
      );
    }
  };
  const handleCloseModalHopDong = () => {
    setShowModalHopDong(false);
    setHopDongDetail(null);
    if (modalKhachHangData) {
      setShowModalKhachHang(true);
    } else {
      setHideParent(false);
    }
  };

  const handleOpenModalKhachHang = (item) => {
    setModalKhachHangData(item);
    setShowModalKhachHang(true);
    setHideParent(true);
  };
  const handleCloseModalKhachHang = () => {
    setShowModalKhachHang(false);
    setHideParent(false);
    setModalKhachHangData(null);
  };

  const handleOpenModalNhanVay = (item) => {
    if (item.NhanVayID) {
      setNhanVayItem(item);
      setShowModalNhanVay(true);
      setHideParent(true);
    }
  };
  const handleCloseModalNhanVay = () => {
    setShowModalNhanVay(false);
    setNhanVayItem(null);
    if (modalKhachHangData) {
      setShowModalKhachHang(true);
    } else {
      setHideParent(false);
    }
  };

  const handleOpenHopDongFromCustomer = (itemGiaoDich) => () => {
    if (itemGiaoDich.NhanVayId && itemGiaoDich.NhanVayId > 0) {
      const itemMap = { ...itemGiaoDich, NhanVayID: itemGiaoDich.NhanVayId };
      setNhanVayItem(itemMap);
      setShowModalNhanVay(true);
      setShowModalKhachHang(false);
      return;
    }
    const choVayId = itemGiaoDich.ChoVayId || itemGiaoDich.ChoVayID;
    if (choVayId) {
      ChiTietHopDong.getChiTietHopDong1(choVayId).then((res) => {
        if (res && res.data) {
          setHopDongDetail(res.data);
          setShowModalHopDong(true);
          setShowModalKhachHang(false);
        }
      });
    }
  };
  const columns = useMemo(
    () => getColumns(mapTypeToInt(type), data.sums, isWinmoney),
    [type, data.sums, isWinmoney],
  );

  return (
    <>
      <Modal
        show={show && !hideParent}
        onHide={onHide}
        size="xl"
        centered
        className="modal-new modal-fade"
      >
        <Modal.Header>
          <div className="d-flex w-100 justify-content-between align-items-center">
            <h4 className="modal-title color7-bold ml-1 mt-1">{title}</h4>
            <button type="button" className="close-popup-new" onClick={onHide}>
              <i className="fa fa-times"></i>
            </button>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: "10px" }}>
          <h5
            className="color-do-bold"
            style={{
              borderBottom: "2px solid #FF5170",
              display: "inline-block",
              paddingBottom: "5px",
              marginBottom: "15px",
            }}
          >
            Danh sách tổng tiền {title.toLowerCase()}
          </h5>
          <div className="Left808x200 Table-main-new css-table-ds">
            <div className="table-mobile table-mobile-hover">
              <div
                className="custom-table-wrapper"
                style={{ overflowX: "auto", width: "100%" }}
              >
                <div
                  className="table-headers"
                  style={{
                    alignItems: "stretch",
                    backgroundColor: "#f8f9fc",
                    borderBottom: "2px solid #ddd",
                  }}
                >
                  <div
                    className="custom-table-header color-do-bold text-center flex-basis-5"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    STT
                    <br />[{data.totalRecords}]
                  </div>
                  {columns.map((col, index) => {
                    const alignHeader =
                      col.align === "text-right"
                        ? "text-right"
                        : col.align === "text-center"
                          ? "text-center"
                          : "text-left";
                    return (
                      <div
                        key={index}
                        className={`custom-table-header ${col.className} ${alignHeader}`}
                        style={{ fontWeight: "bold" }}
                      >
                        {col.header}
                        {col.sum !== undefined && (
                          <>
                            <br />
                            <span className="color-do-bold">
                              {formatNumber2(col.sum)}
                            </span>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="custom-table-body">
                  {loading ? (
                    <div className="text-center p-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      ></div>
                    </div>
                  ) : data.list.length === 0 ? (
                    <div className="text-center p-5">Không có dữ liệu</div>
                  ) : (
                    <ContentTable
                      list={data.list}
                      columns={columns}
                      pageIndex={pageIndex}
                      pageSize={pageSize}
                      onOpenModalHopDong={handleOpenModalHopDong}
                      onOpenModalKhachHang={handleOpenModalKhachHang}
                      onOpenModalNhanVay={handleOpenModalNhanVay}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {data.totalRecords > pageSize && (
            <div className="row mt-1">
              <div className="col-sm-12 col-md-6 d-flex align-items-center">
                <span className="color7">
                  Hiển thị {(pageIndex - 1) * pageSize + 1} -{" "}
                  {Math.min(pageIndex * pageSize, data.totalRecords)} /{" "}
                  {data.totalRecords}
                </span>
              </div>
              <div className="col-sm-12 col-md-6">
                <div className="d-flex justify-content-end">
                  <Pagination
                    activePage={pageIndex}
                    itemsCountPerPage={pageSize}
                    totalItemsCount={data.totalRecords}
                    pageRangeDisplayed={5}
                    onChange={(page) => setPageIndex(page)}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <BtnXuatExcel type={type} filters={filters} />
          {RoleLoiNhuanIn && (
            <BtnInChiTiet type={type} filters={filters} title={title} />
          )}
          <button className="btn btn-new-main btn-closenew" onClick={onHide}>
            Đóng
          </button>
        </Modal.Footer>
      </Modal>

      {showModalHopDong && hopDongDetail && (
        <ChiTietHopDongContainer
          show={showModalHopDong}
          onHide={handleCloseModalHopDong}
          data={hopDongDetail}
          setModalTaiSan={() => {}}
        />
      )}

      {showModalKhachHang && modalKhachHangData && (
        <CustomerDetail
          show={showModalKhachHang}
          onHide={handleCloseModalKhachHang}
          data={{ CustomerID: modalKhachHangData.CustomerID }}
          showChiTietHopDong={handleOpenHopDongFromCustomer}
        />
      )}

      {showModalNhanVay && nhanVayItem && (
        <ModalChiTietHopDong
          show={showModalNhanVay}
          onHide={handleCloseModalNhanVay}
          nhanvayId={nhanVayItem.NhanVayID}
          item={nhanVayItem}
        />
      )}
    </>
  );
};
